import { i18n } from '@/plugins/i18n'

export const templateStatus = {
    ACTIVE: 1,
    NOT_ACTIVE: 2,
}

export const templateStatusStr = {
    ACTIVE: i18n.t('online_contract.status.active'),
    NOT_ACTIVE: i18n.t('online_contract.status.not_active'),
    get(status) {
        let status_str = null;
        Object.keys(templateStatus).forEach(function (item) {
            if(templateStatus[item] === status) {
                status_str = templateStatusStr[item]
            }
        })

        return status_str
    }
}

export const templateStatusVariant = (status) => {
    if(status === templateStatus.ACTIVE) {
        return 'success'
    }

    if(status === templateStatus.NOT_ACTIVE) {
        return 'danger'
    }

    return 'info'
}

export const contractStatus = {
    PENDING : 0,
    SIGNED : 1,
    END : 2,
}

export const contractStatusStr = {
    PENDING: i18n.t('online_contract.status.pending'),
    SIGNED: i18n.t('online_contract.status.signed'),
    END: i18n.t('online_contract.status.end'),
    get(status) {
        let status_str = null;
        Object.keys(contractStatus).forEach(function (item) {
            if(contractStatus[item] === status) {
                status_str = contractStatusStr[item]
            }
        })

        return status_str
    }
}

export const contractStatusVariant = (status) => {
    if(status === contractStatus.SIGNED) {
        return 'success'
    }

    if(status === contractStatus.PENDING) {
        return 'warning'
    }

    return 'dark'
}

export const paymentStatus = {
    PAID_BY_ADMIN : 1,
    UNPAID : 2,
    PAID : 3,
}

export const paymentStatusStr = {
    PAID_BY_ADMIN: i18n.t('online_contract.payment_status.paid_by_admin'),
    UNPAID: i18n.t('online_contract.payment_status.unpaid'),
    PAID: i18n.t('online_contract.payment_status.paid'),

    get(status) {
        let status_str = null;

        Object.keys(paymentStatus).forEach(item => {
            if (paymentStatus[item] === status) {
                status_str = paymentStatusStr[item];
            }
        });

        return status_str;
    }
}

export const contractPaymentStatusVariant = (status) => {
    if(status === paymentStatus.PAID_BY_ADMIN) {
        return 'dark'
    }

    if(status === paymentStatus.UNPAID) {
        return 'warning'
    }

    return 'success'
}
